import TextStyling from './TextStyling';

const ResourcesModule = ({
  coverageSummary = [],
  emailUs = [],
  faq = [],
  fileAClaim = [],
  legalName = '',
  samplePolicy = [],
  title = '',
  purchaseRentalProtection = [],
} = {}) => ({
  coverageSummary: coverageSummary.map((item) => TextStyling(item)),
  emailUs: emailUs.map((item) => TextStyling(item)),
  faq: faq.map((item) => TextStyling(item)),
  fileAClaim: fileAClaim.map((item) => TextStyling(item)),
  legalName: String(legalName),
  samplePolicy: samplePolicy.map((item) => TextStyling(item)),
  title: String(title),
  purchaseRentalProtection: purchaseRentalProtection.map((item) => TextStyling(item)),
});

export type ResourcesModuleProps = ReturnType<typeof ResourcesModule>;

export default ResourcesModule;
